import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoCard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.18117 5.6819H16.8175V14.7728H3.18117V5.6819ZM2.42359 4.16675C2.0052 4.16675 1.66602 4.50593 1.66602 4.92432V15.5304C1.66602 15.9488 2.0052 16.288 2.42359 16.288H17.5751C17.9935 16.288 18.3327 15.9488 18.3327 15.5304V4.92432C18.3327 4.50593 17.9935 4.16675 17.5751 4.16675H2.42359ZM10.7569 7.95463H15.3024V9.46978H10.7569V7.95463ZM14.5448 10.9849H10.7569V12.5001H14.5448V10.9849ZM5.45389 10.9849H6.21147V13.2577H7.72662V9.46978H5.45389V10.9849ZM7.72662 7.19705H6.21147V8.7122H7.72662V7.19705Z",
		fill: "currentColor"
	})
});
export default SvgInfoCard;
